import React, { Component } from 'react';
import { ListItem, Avatar, ListItemText } from '@material-ui/core';
import { Fragment } from 'react';

import { Filters } from './../services/Filters';

const _filters = new Filters();


class ContactItem extends Component {

  render() {
    const { avatar } = this.props.contact;
    const { appLanguage, onSelect } = this.props;
    const person = _filters.translate(this.props.contact.person, appLanguage);
    const name = _filters.translate(this.props.contact.name, appLanguage);

    return (
      <ListItem
        divider
        button
        onClick={onSelect}
      >
        <Fragment>
          {avatar
            ? <Avatar src={avatar} alt={name} />
            : <Avatar>{person ? person.charAt(0) : name.charAt(0)}</Avatar>}
          
          <ListItemText primary={person} secondary={name} /> 
          
        </Fragment>
      </ListItem>
    )
  }
}

export default ContactItem;


// WEBPACK FOOTER //
// ./src/components/ContactItem.js